<template>
  <div class="component">
    <p v-if="component.type == 'PARAGRAPH'" :data-whitespace="component.whitespace" v-html="formattedLabel"></p>
    <h3 v-else-if="component.headerSize == 'h3'">{{ component.label }}</h3>
    <h2 v-else-if="component.headerSize == 'h2'">{{ component.label }}</h2>
    <h1 v-else>{{ component.label }}</h1>
    <img src="@/assets/trash.png" alt="trash" class="icon-sm" v-if="showTrash" @click="deleteComponent">
  </div>
</template>

<script>
export default {
  name: "InputComponent",
  props: {
    component: Object,
    interactable: Boolean,
    showTrash: Boolean,
  },
  computed: {
    formattedLabel() {
      return this.replaceLinks(this.component.label);
    },
  },
  methods: {
    deleteComponent() {
      this.$emit("deleteComponent");
    },
    replaceLinks(text) {
      // Regex to detect URLs in the text.
      const urlRegex = /(\b(https?):\/\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])/ig;
      // Replace URLs with <a> elements that open in a new tab.
      return text.replace(urlRegex, '<a target="_blank" href="$1">$1</a>');
    },
  },
  emits: ["deleteComponent"],
};
</script>

<style scoped>
.component {
  position: relative;
  display: block;
  flex: 1;
}

h1 {
  margin-bottom: 0px;
  margin-top: 50px;
}

h2 {
  margin-bottom: 0px;
  margin-top: 25px;
}

.icon-sm {
  display: block;
  position: absolute;
  top: 0px;
  right: 0px;
  height: 25px;
  filter: saturate(0);
  background: #fff;
}

.icon-sm:hover {
  cursor: pointer;
  filter: none;
}

p[data-whitespace="true"] {
  white-space: pre-line;
}
</style>